<template>
  <div class="text-sm text-center mt-4">
    <label class="form-label"><input type="checkbox" v-model="isSelected"> Comparar</label>
  </div>
</template>
<script>
import { globalEventBus } from '../../_globalEventBus';
export default {
  name: 'compare-product',
  props: {
    product: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isSelected: null,
    }
  },
  watch: {
    isSelected(newVal, oldVal) {
      if (oldVal == null) {
        return;
      }

      globalEventBus.$emit(
        'productCompared',
        {
          product: this.product,
          selected: newVal
        }
      );
    }
  },
  methods: {
    checkCompared: async function() {
      try {
        let res = await axios.get(`/productos/comparar/esta-comparado?category=${this.category}&product=${this.product}`);
        let { data } = await res.data;
        this.isSelected = data;
      } catch(e) {
      }
    },
  },
  mounted() {
    this.checkCompared();

    globalEventBus.$on('comparisonRejected', data => {
      if (data == this.product) {
        setTimeout(() => {
          this.isSelected = false;
        }, 250);
      }
    });
    
    globalEventBus.$on('clearComparison', data => {
      if (data == this.category) {
        this.isSelected = false;
      }
    });
  }
}
</script>